var projectTimeline = {
	"Project timeline": "Cronograma del proyecto",
	"None planned": "Aún no está planificado",
	"1-3 months": "De 1 a 3 meses",
	"4-6 months": "4 a 6 meses",
	"7-12 months": "7 a 12 meses",
	"More than 1 year": "Más de 1 año"
};

export { projectTimeline as default };
